export const VIDEO_MONO = 1;
export const VIDEO_STEREO = 2;
export const IMAGE = 3;
